import type { LoanApplicationData } from "../hooks/useNbiForm";
import { handleEmploymentContract } from "./parser/employmentContractParser";
import { handleExpenseDocument } from "./parser/expenseParser";
import { handleIdentityDocument } from "./parser/identityConfirmationParser";
import { handleIncomeDocument } from "./parser/incomeParser";
import type {
    EmploymentContract,
    IdentityConfirmation,
    IncomePayload,
    RootDataStructure,
    SetFieldValueCallback,
} from "./parser/models";

export const parseDocumentEvent = (
    eventData: RootDataStructure,
    currentFormData: LoanApplicationData,
    setFieldValue: SetFieldValueCallback,
    defaultCurrency: string = "AUD"
): void => {
    /**
     * The order matter here:
     * we need to apply the changes in the order below:
     * - applicant
     * - employment
     * - income
     *
     * this happens because when we import a payincome before a application or employment. we need to create a
     * basic applicant and/or basic employment to associate with this income. Same tthing happens when we create
     * an employment before a applicant associated with it.
     *
     *
     * new event structure has the attributes:
     * - applicant  => applicant data is inside it
     * - employment => employment data is inside it
     * - income     => income data is inside it
     * TODO: old fields weren't removed yet because retrocompatibily during the feature implementation
     */

    let applicantId: string | null = null;
    if ("applicant" in eventData) {
        const rootData = eventData as RootDataStructure;
        applicantId = handleIdentityDocument(
            rootData.applicant as IdentityConfirmation,
            currentFormData,
            setFieldValue
        );
    }

    let employmentId: string | null = null;
    if ("employment" in eventData) {
        const rootData = eventData as RootDataStructure;
        employmentId = handleEmploymentContract(
            rootData.employment as EmploymentContract,
            currentFormData,
            setFieldValue,
            applicantId
        );
    }

    if ("income" in eventData) {
        const incomeData = eventData.income as IncomePayload;
        handleIncomeDocument(incomeData, currentFormData, setFieldValue, applicantId, employmentId, defaultCurrency);
    }

    if ("expense" in eventData) {
        handleExpenseDocument(eventData.expense, currentFormData, setFieldValue);
    }
};
